module.exports = __webpack_public_path__ + "img/3-3.1bf294ce.svg";